import { useMemo } from 'react';

import {
  FixedDataPicker,
  IEnumPickerProps,
} from '@work4all/components/lib/components/entity-picker/fixed-data-picker/FixedDataPicker';

import { WebShopType } from '@work4all/models/lib/Enums/WebShopType.enum';

export interface WebShopTypePickerProps
  extends Omit<
    IEnumPickerProps<false>,
    'multiple' | 'value' | 'onChange' | 'dataSet'
  > {
  value: WebShopType;
  onChange: (value: WebShopType) => void;
}

type Option = {
  id: WebShopType;
  name: WebShopType;
};

const OPTIONS = Object.values(WebShopType).map((type) => {
  return { id: type, name: type };
});

export function WebShopTypePicker(props: WebShopTypePickerProps) {
  const { value, onChange, ...others } = props;

  const pickerValue = useMemo(() => {
    return {
      id: value,
      name: value,
    };
  }, [value]);

  const handleChange = (value: Option) => {
    onChange(value ? value.id : null);
  };

  return (
    <FixedDataPicker
      multiple={false}
      value={pickerValue}
      onChange={handleChange}
      dataSet={OPTIONS}
      {...others}
    />
  );
}
